



<div class="homeView">

  <div class="enterVideo homeView__enterVideo" *ngIf="showWickedVideo">
    <div class="enterVideo__wrap">
      <div style="padding: 56.25% 0 0 0; position: relative;">
        <div
          id="wickedvid"
          #wickedvideo
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
        ></div>
        <div class="enterVideo__vimeoSkip">
          <button
            mat-button
            mat-flat-button
            color="accent"
            (click)="skipVideoPlay($event)"
            class="vimeo-skip-button"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
    <div class="homeView__skipTop" (click)="skipVideoPlay($event)">
      <img src="skip.png" />
    </div>
  </div>

  <app-search></app-search>

  <div class="adsContainer mt0" *ngIf="(!isPremium || !service.enableSubscription)">
    <app-banner-zone-map [zoneType]="'Mobile-Ads'" [isMobile]="true"></app-banner-zone-map>
  </div>

  <h2 class="homeView__title">Popular cities:</h2>
  <mat-list class="homeView__citiesList"  role="list">
    <mat-list-item class="cityItem homeView__cityItem"  role="cityitem" *ngFor="let city of mostPopularCities | async">
        <a class="cityItem__btn" mat-raised-button [routerLink]="getCityUrl(city)">
            <span class="cityItem__name">{{city.name}}</span>
        </a>
    </mat-list-item>
  </mat-list>

  <div class="adsContainer" *ngIf="(!isPremium || !service.enableSubscription)">
    <app-banner-zone-map [zoneType]="'Mobile-Ads-2'" [isMobile]="true"></app-banner-zone-map>
  </div>
</div>